/**
 * Tiny SplitText replacement (the GSAP plugin is paid). Wraps every word of an element in
 *   <span class="split-word"><span class="split-word__inner">word</span></span>
 * so words can slide up from a mask. Inline elements such as <em> are kept and split inside;
 * elements with .scribble-word (they carry an SVG underline) are wrapped whole, unmasked.
 * The original text is kept as an aria-label so screen readers read the heading naturally.
 */
export function splitWords(el) {
  if (el.dataset.splitDone) return el.querySelectorAll('.split-word__inner');
  const label = el.textContent.replace(/\s+/g, ' ').trim();

  const makeWord = (content, open = false) => {
    const outer = document.createElement('span');
    outer.className = open ? 'split-word split-word--open' : 'split-word';
    outer.setAttribute('aria-hidden', 'true');
    const inner = document.createElement('span');
    inner.className = 'split-word__inner';
    if (typeof content === 'string') inner.textContent = content;
    else inner.appendChild(content);
    outer.appendChild(inner);
    return outer;
  };

  const walk = (node) => {
    [...node.childNodes].forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        const parts = child.textContent.split(/(\s+)/);
        const frag = document.createDocumentFragment();
        parts.forEach((part) => {
          if (!part) return;
          frag.appendChild(/^\s+$/.test(part) ? document.createTextNode(' ') : makeWord(part));
        });
        child.replaceWith(frag);
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        if (child.classList.contains('scribble-word') || child.tagName === 'svg' || child.tagName === 'BR') {
          if (child.tagName === 'BR') return;
          const placeholder = document.createComment('');
          child.replaceWith(placeholder);
          placeholder.replaceWith(makeWord(child, true));
        } else {
          walk(child);
        }
      }
    });
  };

  walk(el);
  el.setAttribute('aria-label', label);
  el.dataset.splitDone = '1';
  return el.querySelectorAll('.split-word__inner');
}
